import { CampaignV2 } from 'shared/src/api/campaigns-v2';
import { DBStrategy } from 'shared/src/types';

export function isAgencyMarkupZohoCampaign(campaign: CampaignV2): boolean {
  return campaign.agency_gross_markup != null && campaign.agency_gross_markup > 0;
}

export function isReferralCommissionZohoCampaign(campaign: CampaignV2): boolean {
  return campaign.referral_commission === true;
}

export function isDefinedStrategy(proposal: DBStrategy): proposal is DBStrategy {
  return proposal.price !== null && proposal.start_date !== null && proposal.end_date !== null;
}

export function isAgencyMarkupStrategy(strategy: DBStrategy) {
  return !!strategy.agency_markup_rate && strategy.agency_markup_rate > 0;
}

export function isReferralCommissionStrategy(strategy: DBStrategy) {
  return !!strategy.referral_commission_rate && strategy.referral_commission_rate > 0;
}
